/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import '~styles/modules/menuGrid.scss';

const MenuGrid = ({ data }) => {
  const photo = data.url
  const quote = data.quote
  const anchor = data.subject

  //const image = "style='background-image: url("+photo+"')"

  return (
  	<div className="grid-rows">
    	<a href={"#"+anchor} target="_self">
			<div className="grid-image-containers grid-cols">
				<img
					className="grid-img"
				  	src={photo}
				/>
			</div>
			<div className="grid-quote-containers grid-cols">
				“{quote}”
			</div>
	    </a>
	</div>
  );

};




export default MenuGrid;
